import { ROUTE_RULE_MESSAGE, isRoute } from "../../shared/shops/route.js";

export const SHOP_ROUTE_RULE_MESSAGE = ROUTE_RULE_MESSAGE;

const ROUTE_MAX_LENGTH = 50;

const COMBINING_MARKS = /[\u0300-\u036f]/g;
const UNDERSCORES_AND_SPACES = /[_\s]+/g;
const DISALLOWED_IN_ROUTE = /[^0-9a-zA-Z-]/g;
const REPEATED_DASHES = /-+/g;
const LEADING_DASHES = /^-+/;
const TRAILING_DASHES = /-+$/;

export const isShopRoute = isRoute;

export const normalizeShopRouteInput = (value = "") =>
  value
    .normalize("NFD")
    .replace(COMBINING_MARKS, "")
    .replace(UNDERSCORES_AND_SPACES, "-")
    .replace(DISALLOWED_IN_ROUTE, "")
    .replace(REPEATED_DASHES, "-")
    .replace(LEADING_DASHES, "")
    .toLowerCase()
    .slice(0, ROUTE_MAX_LENGTH);

export const finalizeShopRouteInput = (value = "") =>
  normalizeShopRouteInput(value).replace(TRAILING_DASHES, "");

export const settleShopRouteInput = (savedRoute) => (value) =>
  value === savedRoute ? value : finalizeShopRouteInput(value);
